export const ADD_COURSE = "ADD_COURSE";
export const ADD_MODULE = "ADD_MODULE";
export const ADD_COURSE_RESET = "ADD_COURSE_RESET";
export const ADD_MODULE_RESET = "ADD_MODULE_RESET";
export const ADD_MODULE_SHOW = "ADD_MODULE_SHOW";
export const STEPPER_NEXT = "STEPPER_NEXT";
export const PLAY_VIDEO = "PLAY_VIDEO";
export const PERCENT_AGE = "PERCENT_AGE";
export const STEPPER_COHORT = "STEPPER_COHORT";
export const STEPPER_COURSES = "STEPPER_COURSES";
export const JUMP_PAGE = "JUMP_PAGE";
export const COURSEID = "COURSEID";
export const UPDATE_PREV_TAG_STATE = "UPDATE_PREV_STATE";
export const GetFilteredData = "GetFilteredData";
export const isPodcastView = "isPodcastView";
export const isAssignLearnerStep = "isAssignLearnerStep";
export const isSeatingCapacityFull = "isSeatingCapacityFull";
export const masterCourseID = "masterCourseID";
export const isClonedCourse = "isClonedCourse";
export const Nomination_EndDate = "Nomination_EndDate";
export const courseStartDate = "courseStartDate";
export const classroomTimings = "classroomTimings";
export const getPreviousBatchEmployees = "getPreviousBatchEmployees";
export const SET_SELECTED_EMPLOYEES = "SET_SELECTED_EMPLOYEES";
export const userRoleAccess = "userRoleAccess";
export const lmsReqApprove = "lmsReqApprove";
export const reassignCoordinator = "reassignCoordinator";
export const superAdminUserName = "superAdminUserName";
export const nominatedCourseID = "nominatedCourseID";
export const iseditClonedCourse = "iseditClonedCourse";

